import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContributeButton from '../../../../../components/global/ContributeButton/ContributeButton';
import useOpenModal from '../../../../../hooks/useOpenModal';
import { getThumbBySize } from '../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import { isAlbumOwner } from '../../../../../util/account';
import ListingCardTemplate from '../../../../pro/components/ListingCardTemplate';
import Button from '../../../../../components/global/Button';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../../constants/modals';
import { getCelebratedPersonName } from '../../../../pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';

const propTypes = {
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  className: PropTypes.string,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  ),
  thumbnailActions: PropTypes.node,
  title: PropTypes.string,
  eventSettings: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
};

const WebGalleryMemoryBookListingCard = ({
  linkTo,
  onClick,
  user,
  album,
  thumbnails,
  className,
  thumbnailActions,
  title,
  eventSettings,
}) => {
  const openModal = useOpenModal();
  const thumbnailUrl = getThumbBySize(
    thumbnails ?? [],
    IMAGE_SIZE_CODE.MEDIUM2X,
    // Important for when using local cache
    true,
  )?.url;

  const classes = classNames({
    'album-card': true,
    'memory-book-card': true,
    'with-thumbnail': !!thumbnailUrl,
    [className]: !!className,
  });

  const buttonContainerClasses = classNames({
    'listing-card-template-cover-null-state-actions-buttons': true,
  });
  const isOwner = isAlbumOwner(user, album);

  const celebratedName = getCelebratedPersonName(
    album.album_subtype,
    eventSettings,
    false,
  );

  return (
    <ListingCardTemplate
      className={classes}
      linkTo={linkTo}
      onClick={onClick}
      title={title ?? album?.name}
      thumbnailUrl={thumbnailUrl}
      thumbnailActions={thumbnailActions}
      note={
        <Fragment>
          {!thumbnailUrl && (
            <Fragment>
              {isOwner && <p>Design your memories slideshow!</p>}
              {!isOwner && <p>Add your old photos of {celebratedName}!</p>}
            </Fragment>
          )}

          <div className={buttonContainerClasses}>
            <ContributeButton
              albumId={album?.id}
              btnBlock={!!thumbnailUrl}
              className="text-uppercase"
              btnStyle={thumbnailUrl ? 'white' : 'primary'}
              btnOutline
              btnSize={thumbnailUrl ? 'sm' : 'xs'}
            >
              Upload
            </ContributeButton>
            <Button
              btnBlock={!!thumbnailUrl}
              className="text-uppercase"
              btnStyle={thumbnailUrl ? 'white' : 'primary'}
              btnOutline
              btnSize={thumbnailUrl ? 'sm' : 'xs'}
              onClick={event => {
                event.preventDefault();
                openModal(CONTRIBUTOR_SHARE_MODAL);
              }}
            >
              Share
            </Button>
          </div>
        </Fragment>
      }
    />
  );
};

WebGalleryMemoryBookListingCard.propTypes = propTypes;

export default WebGalleryMemoryBookListingCard;
